import React, { useState, useRef } from "react";
import axios from "axios";
import { ImportIcon, X } from "lucide-react";
import Successpage from "./Successpage.jsx";
import { useSuperAdmin } from "../context/SuperAdminContext.jsx";
import sampleCSV from '../assets/sample.csv';



const AttendanceFile = ({
  departments,
  showuploadfilemodal,
  setshowuploadfilemodal,
  Success,
  setSuccess,
  selectedCompany
}) => {

  const { loading, attendancefiledatafetch } = useSuperAdmin();


  const [response, setresponse] = useState(null)

  const [entryId, setentryId] = useState("")


  const [File, setFile] = useState(null);
  // const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  // Message modal states
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [uploadResults, setUploadResults] = useState(null);

  // Success page modal
  const [entriesmodal, setentriesmodal] = useState(false);
  const [timestamp, settimestamp] = useState()


  // ---------- DRAG & DROP HANDLERS ----------
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!e.dataTransfer.files[0]) return;
    if (!e.dataTransfer.files[0].name.match(/\.(csv|xlsx|xls)$/)) {
    showModal("Error", "Please select a valid CSV or Excel file");
    e.target.value = "";
    return;
  }
    setFile(e.dataTransfer.files[0]);
  };


  // Show modal helper
  const showModal = (title, message, results = null) => {
    setModalTitle(title);
    setModalMessage(message);
    setUploadResults(results);
    setShowMessageModal(true);
  };

  // File select
  const handleFileChange = (e) => {
  const selectedFile = e.target.files?.[0];
  if (!selectedFile) return;

  if (!selectedFile.name.match(/\.(csv|xlsx|xls)$/)) {
    showModal("Error", "Please select a valid CSV or Excel file");
    e.target.value = "";
    return;
  }

  setFile(selectedFile);
};

// Submit
const handleSubmit = async () => {
  if (!File) {
    showModal("Error", "Please select a file first");
    return;
  }

  const formdata = new FormData();
  formdata.append("file", File);
  try {
    const token = localStorage.getItem("superadmintoken");
    console.log("timestamp",timestamp)

    const apiresponse = await attendancefiledatafetch(
      formdata,
      selectedCompany,
      token
    );
    if(!apiresponse.message)
    {
       showModal(
      "Error",
      `${apiresponse.message}`,
      setresponse(null)
    );

    }
    else{
    setresponse(apiresponse);
    console.log("apiresponse",response)
    setSuccess(true);
    setshowuploadfilemodal(false);
    setentriesmodal(true);
    setentryId(apiresponse.entryId);
    const time=apiresponse?.finalTimestamp;
    settimestamp(time)
}
    

 

    

  } catch (error) {
    showModal(
      "Upload Failed",
      "Something went wrong while uploading the file. Please try again."
    );
  }
};

  // Close upload modal
  const handleClose = () => {
    setshowuploadfilemodal(false);
    setSuccess(false);
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

    const downloadSampleCSV = () => {
    const link = document.createElement('a');
    link.href = "https://fk-offerletters.s3.ap-south-1.amazonaws.com/development/on-demand-bulk-entry/requested/68f1dd7a8d5bd56f07b78a5d-1772001809112.csv"
;
    link.download = 'sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {showuploadfilemodal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-gray-100 rounded-lg p-6 max-w-xl w-full mx-4 min-h-[300px] border border-gray-300">

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-gray-800">
                Upload Attendance File
              </h2>
              <button onClick={handleClose
              }>
                <X className="h-5 w-5 text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div>
                          <div className="flex justify-end mb-2">
                                <button
      onClick={downloadSampleCSV}
      className="text-blue-500 hover:text-blue-700 underline text-sm mt-4"
    >
      Download Sample CSV
    </button>
                </div>
            </div>

            {/* Upload UI */}
            {!Success && (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={handleFileChange}
                  className="hidden"
                />

                <div
                  onClick={() => fileInputRef.current.click()}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-indigo-500 transition"
                >
                  <ImportIcon className="h-10 w-10 mx-auto text-gray-400 mb-3" />
                  <p className="text-gray-600 font-medium">
                    Click to upload or drag and drop
                  </p>
                  <p className="text-sm text-gray-400 mt-1">
                    CSV, XLSX files only
                  </p>

                  {File && (
                    <div className="flex justify-center items-center gap-2 mt-3 text-sm text-green-600 font-semibold">
                      <span>{File.name}</span>
                      <X
                        className="h-4 w-4 text-red-500 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFile(null);
                          if (fileInputRef.current)
                            fileInputRef.current.value = "";
                        }}
                      />
                    </div>
                  )}
                </div>

                <button
                  onClick={handleSubmit}

                  disabled={!File || loading}
                  className="w-full mt-4 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300"
                >
                  {loading ? "Uploading..." : "Upload File"}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Message Modal */}
      {showMessageModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">

            <div className="flex flex-col items-center text-center">
  {/* Icon */}
  {modalTitle === "Success" ? (
    <div className="mb-3 flex items-center justify-center w-12 h-12 rounded-full bg-green-100">
      <span className="text-green-600 text-2xl">✓</span>
    </div>
  ) : modalTitle === "Error" ||modalTitle === "Upload Failed"  ? (
    <div className="mb-3 flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
      <span className="text-red-600 text-2xl">✕</span>
    </div>
  ) : null}

  {/* Title */}
  <h3
    className={`text-lg font-semibold mb-2 ${
      modalTitle === "Success"
        ? "text-green-600"
        : modalTitle === "Error"
        ? "text-red-600"
        : "text-gray-800"
    }`}
  >
    {modalTitle}
  </h3>

  {/* Message */}
  <p className="text-sm text-gray-600 mb-4">{modalMessage}</p>
</div>


            <button
              onClick={() => {
                setShowMessageModal(false);
                setFile(null);
                if (fileInputRef.current)
                  fileInputRef.current.value = "";
              }}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md"
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Success Page */}
      {entriesmodal && response && (
        <Successpage
          response={response}
          setentriesmodal={setentriesmodal}
          setSuccess={setSuccess}
          setFile={setFile}
          setshowuploadfilemodal={setshowuploadfilemodal}
          showModal={showModal}
          selectedCompany={selectedCompany}
          departments={departments}
          setresponse={setresponse}
          entryId={entryId}
          timestamp={timestamp}
          settimestamp={settimestamp}
        />
      )}
    </>
  );
};

export default AttendanceFile;

